import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { io, Socket } from 'socket.io-client';
import { environment } from '../environments/environment';
import { AppService } from './app.service';

export type WebSocketListener = {
  removeListener: () => void;
};

@Injectable({
  providedIn: 'root',
})
export class WebSocketService {
  private instance: Socket = null;

  startMachineStatus$: BehaviorSubject<any[]> = new BehaviorSubject([]);
  topupStatus$: BehaviorSubject<any[]> = new BehaviorSubject([]);

  constructor(private appService: AppService) {}

  async client(): Promise<Socket> {
    if (this.instance) {
      return this.instance;
    }

    // [2025-06-20 @ Dino] If has token then start, if not just ignore don't throw
    // because user can access the routes directly
    if (!this.appService.accessToken) {
      return;
    }

    this.instance = io(environment.baseWebSocketUrl, {
      path: environment.baseWebSocketUrlPath,
      extraHeaders: {
        Authorization: `Bearer ${this.appService.accessToken}`,
      },
    });

    this.instance.on('message', (payload) => {
      if (payload.name === 'Client ID') {
        this.instance.id = payload.data.clientId;
      }
    });

    this.instance.on(`${this.appService.appUuid}_payAndStart`, (payload) => {
      this.startMachineStatus$.next([payload]);
    });

    this.instance.onAny((eventName, ...args) => {
      const topUpEventMatch = /(.*)_topup_(.*)/.exec(eventName);

      if (topUpEventMatch) {
        const uuid = topUpEventMatch[1];
        const orderNumber = topUpEventMatch[2];

        if (uuid === this.appService.appUuid) {
          this.topupStatus$.next([
            {
              orderNumber,
              payload: args[0],
            },
          ]);
        }
      }
    });

    return this.instance;
  }

  resetStartMachineStatus(): void {
    this.startMachineStatus$.next([]);
  }

  resetTopUpStatus(): void {
    this.topupStatus$.next([]);
  }
}
